import { Typography } from '@mui/material';
import React from 'react';

const Footer = () => {
    return <div style={{background:'#000c57',position:'fixed', bottom:0, width:'100%', height: 50, color:'#fff', lineHeight:'50px', textAlign:'center', verticalAlign:'middle'}}>
        <Typography variant='body2' style={{lineHeight:'50px'}}>Target# is a product of New Century Production</Typography>
    </div>
}
export default Footer;